<template>
  <div :class="[baseCss]">
    <brand-color v-for="(hex, name) in colors" :key="hex" :name="name" :hex="hex" />
  </div>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'ThemeColors',
  mixins: [
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('theme-colors', [])
    }
  },
  props: {
    colors: {
      type: Object,
      default () {
        return {
          primary: '#e31818',
          secondary: '#d2005c',
          tertiary: '#a33285',
          accent: '#65498e',
          positive: '#0fb981',
          negative: '#f43f5e',
          info: '#3b82f6',
          warning: '#f59e0b'
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/theme-colors/theme-colors.vue